module.exports = __webpack_public_path__ + "img/mobile/Banners-freespins/288_title_freespins_chinese@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Banners-freespins/288_title_freespins_chinese@2x.png
// module id = 591
// module chunks = 0